import { c } from '../../utils/tailwind-merge';
import { Badge } from '../Badge/Badge';
import { BadgeListProps } from './types';

const baseClasses =
  'relative z-overlay flex w-full flex-row gap-x-2 items-start md:flex-row md:gap-x-2';

export const BadgeList = ({ data }: BadgeListProps) => {
  const badgeList = (
    <>
      {data.isUpm && (
        <Badge text={data.upmText || ''} appearance="badgeWithIcon" />
      )}
      {data.isVerifiedSolution && (
        <Badge
          text={data.verifiedSolutionText || ''}
          iconName="HexagonWithCheck"
          appearance="badgeWithIcon"
        />
      )}
    </>
  );

  return (
    <div className={c(baseClasses, data.className || '')}>{badgeList}</div>
  );
};
